export function combineLoaders<T>(
  ...loaders: ((args: T) => Promise<Record<string, unknown>>)[]
) {
  return async (args: T) => {
    const results = await Promise.all(loaders.map(loader => loader(args)));
    return Object.assign({}, ...results);
  };
}
